/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
export const yellow = {
    50: '#FFF9E3',
    100: '#FFF2C2',
    200: '#FFEBA6',
    300: '#FFE588',
    400: '#FFDC62',
    500: '#FFD43A',
    600: '#FFCD1E',
    700: '#FBC508',
    800: '#E5B300',
    900: '#B58D02',
    1000: '#886A00',
};
